export default __webpack_public_path__ + "static/Hatton-Regular-76daa0c4c3c07e86a1e3304b82f4166b.woff";